import { render, staticRenderFns } from "./content-view.vue?vue&type=template&id=1ba82758&"
import script from "./content-view.vue?vue&type=script&lang=js&"
export * from "./content-view.vue?vue&type=script&lang=js&"
import style0 from "./content-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports